module.exports = __webpack_public_path__ + "static/media/eng.ba0b48d2.svg";